import _extends from '@babel/runtime/helpers/esm/extends';
import React, { forwardRef } from 'react';
import { Box } from '@chakra-ui/react';
import { FiActivity, FiAirplay, FiAlertCircle, FiAlertOctagon, FiAlertTriangle, FiAlignCenter, FiAlignJustify, FiAlignLeft, FiAlignRight, FiAnchor, FiAperture, FiArchive, FiArrowDownCircle, FiArrowDownLeft, FiArrowDownRight, FiArrowDown, FiArrowLeftCircle, FiArrowLeft, FiArrowRightCircle, FiArrowRight, FiArrowUpCircle, FiArrowUpLeft, FiArrowUpRight, FiArrowUp, FiAtSign, FiAward, FiBarChart2, FiBarChart, FiBatteryCharging, FiBattery, FiBellOff, FiBell, FiBluetooth, FiBold, FiBookOpen, FiBook, FiBookmark, FiBox, FiBriefcase, FiCalendar, FiCameraOff, FiCamera, FiCast, FiCheckCircle, FiCheckSquare, FiCheck, FiChevronDown, FiChevronLeft, FiChevronRight, FiChevronUp, FiChevronsDown, FiChevronsLeft, FiChevronsRight, FiChevronsUp, FiChrome, FiCircle, FiClipboard, FiClock, FiCloudDrizzle, FiCloudLightning, FiCloudOff, FiCloudRain, FiCloudSnow, FiCloud, FiCode, FiCodepen, FiCodesandbox, FiCoffee, FiColumns, FiCommand, FiCompass, FiCopy, FiCornerDownLeft, FiCornerDownRight, FiCornerLeftDown, FiCornerLeftUp, FiCornerRightDown, FiCornerRightUp, FiCornerUpLeft, FiCornerUpRight, FiCpu, FiCreditCard, FiCrop, FiCrosshair, FiDatabase, FiDelete, FiDisc, FiDivideCircle, FiDivideSquare, FiDivide, FiDollarSign, FiDownloadCloud, FiDownload, FiDribbble, FiDroplet, FiEdit2, FiEdit3, FiEdit, FiExternalLink, FiEyeOff, FiEye, FiFacebook, FiFastForward, FiFeather, FiFigma, FiFileMinus, FiFilePlus, FiFileText, FiFile, FiFilm, FiFilter, FiFlag, FiFolderMinus, FiFolderPlus, FiFolder, FiFramer, FiFrown, FiGift, FiGitBranch, FiGitCommit, FiGitMerge, FiGitPullRequest, FiGithub, FiGitlab, FiGlobe, FiGrid, FiHardDrive, FiHash, FiHeadphones, FiHeart, FiHelpCircle, FiHexagon, FiHome, FiImage, FiInbox, FiInfo, FiInstagram, FiItalic, FiKey, FiLayers, FiLayout, FiLifeBuoy, FiLink2, FiLink, FiLinkedin, FiList, FiLoader, FiLock, FiLogIn, FiLogOut, FiMail, FiMapPin, FiMap, FiMaximize2, FiMaximize, FiMeh, FiMenu, FiMessageCircle, FiMessageSquare, FiMicOff, FiMic, FiMinimize2, FiMinimize, FiMinusCircle, FiMinusSquare, FiMinus, FiMonitor, FiMoon, FiMoreHorizontal, FiMoreVertical, FiMousePointer, FiMove, FiMusic, FiNavigation2, FiNavigation, FiOctagon, FiPackage, FiPaperclip, FiPauseCircle, FiPause, FiPenTool, FiPercent, FiPhoneCall, FiPhoneForwarded, FiPhoneIncoming, FiPhoneMissed, FiPhoneOff, FiPhoneOutgoing, FiPhone, FiPieChart, FiPlayCircle, FiPlay, FiPlusCircle, FiPlusSquare, FiPlus, FiPocket, FiPower, FiPrinter, FiRadio, FiRefreshCcw, FiRefreshCw, FiRepeat, FiRewind, FiRotateCcw, FiRotateCw, FiRss, FiSave, FiScissors, FiSearch, FiSend, FiServer, FiSettings, FiShare2, FiShare, FiShieldOff, FiShield, FiShoppingBag, FiShoppingCart, FiShuffle, FiSidebar, FiSkipBack, FiSkipForward, FiSlack, FiSlash, FiSliders, FiSmartphone, FiSmile, FiSpeaker, FiSquare, FiStar, FiStopCircle, FiSun, FiSunrise, FiSunset, FiTablet, FiTag, FiTarget, FiTerminal, FiThermometer, FiThumbsDown, FiThumbsUp, FiToggleLeft, FiToggleRight, FiTool, FiTrash2, FiTrash, FiTrello, FiTrendingDown, FiTrendingUp, FiTriangle, FiTruck, FiTv, FiTwitch, FiTwitter, FiType, FiUmbrella, FiUnderline, FiUnlock, FiUploadCloud, FiUpload, FiUserCheck, FiUserMinus, FiUserPlus, FiUserX, FiUser, FiUsers, FiVideoOff, FiVideo, FiVoicemail, FiVolume1, FiVolume2, FiVolumeX, FiVolume, FiWatch, FiWifiOff, FiWifi, FiWind, FiXCircle, FiXOctagon, FiXSquare, FiX, FiYoutube, FiZapOff, FiZap, FiZoomIn, FiZoomOut } from 'react-icons/fi';
import { FaFacebook, FaCcAmex, FaCcDinersClub, FaCcDiscover, FaCcJcb, FaCcMastercard, FaCcVisa, FaTruck } from 'react-icons/fa';
import propTypes from 'prop-types';
import { BiBadgeCheck } from 'react-icons/bi';

var GoogleIconPath = function GoogleIconPath() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6088 4.64C14.8621 4.64 16.3821 5.61333 17.2488 6.42667L20.6355 3.12C18.5555 1.18667 15.8488 0 12.6088 0C7.91546 0 3.86213 2.69333 1.88879 6.61333L5.76879 9.62667C6.74213 6.73333 9.43546 4.64 12.6088 4.64Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1288 12.2668C24.1288 11.2801 24.0488 10.5601 23.8754 9.81348H12.6088V14.2668H19.2221C19.0888 15.3735 18.3688 17.0401 16.7688 18.1601L20.5554 21.0935C22.8221 19.0001 24.1288 15.9201 24.1288 12.2668Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7821 14.3733C5.52876 13.6266 5.3821 12.8266 5.3821 11.9999C5.3821 11.1733 5.52876 10.3733 5.76876 9.62661L1.88876 6.61328C1.07543 8.23995 0.608765 10.0666 0.608765 11.9999C0.608765 13.9333 1.07543 15.7599 1.88876 17.3866L5.7821 14.3733Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6086 23.9997C15.8486 23.9997 18.5686 22.933 20.5553 21.093L16.7686 18.1597C15.7553 18.8664 14.3953 19.3597 12.6086 19.3597C9.43531 19.3597 6.74198 17.2664 5.78198 14.373L1.90198 17.3864C3.87531 21.3064 7.91531 23.9997 12.6086 23.9997Z",
    fill: "#34A853"
  }));
};
var GoogleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: GoogleIconPath
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  GoogleIcon.displayName = 'GoogleIcon';
}
var AppleIconPath = function AppleIconPath() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2482 0C17.4628 1.45774 16.8695 2.88585 16.0868 3.89625C15.2493 4.98003 13.8059 5.81827 12.4074 5.77452C12.1521 4.37887 12.8058 2.94089 13.6011 1.97423C14.4736 0.907384 15.9689 0.0889039 17.2482 0ZM21.4494 20.5186C22.1704 19.4136 22.4397 18.8562 22.9994 17.6087C18.9287 16.0607 18.2764 10.2734 22.305 8.05225C21.0763 6.51125 19.3495 5.61798 17.7195 5.61798C16.5451 5.61798 15.7404 5.92447 15.0088 6.2031C14.3992 6.43529 13.8404 6.64814 13.1607 6.64814C12.4262 6.64814 11.7757 6.41493 11.0947 6.17073C10.3463 5.9024 9.56092 5.6208 8.58638 5.6208C6.75723 5.6208 4.81025 6.73845 3.57585 8.64918C1.84067 11.3403 2.13665 16.3993 4.95052 20.7091C5.95627 22.2515 7.30008 23.9844 9.0577 23.9999C9.787 24.0072 10.2723 23.7895 10.7975 23.5539C11.3986 23.2843 12.0519 22.9913 13.1831 22.9853C14.321 22.9785 14.964 23.2751 15.5571 23.5486C16.0688 23.7847 16.5434 24.0035 17.2664 23.9957C19.0255 23.9816 20.4436 22.061 21.4494 20.5186Z",
    fill: "#0B0B0A"
  }));
};
var AppleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: AppleIconPath
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AppleIcon.displayName = 'AppleIcon';
}
var FaFacebookIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FaFacebook
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FaFacebookIcon.displayName = 'FaFacebookIcon';
}

var BadgeCheckIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: BiBadgeCheck,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BadgeCheckIcon.displayName = 'BadgeCheckIcon';
  BadgeCheckIcon.propTypes = {
    color: propTypes.string
  };
}

var FlareIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    ref: ref,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: "2",
    stroke: "currentColor",
    strokeLinecap: "round",
    color: "scheme.textPrimary",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.7l8 4.3M14 2l4 9.1M6 21.7l8.3-1.2"
  }));
});
if (process.env.NODE_ENV !== 'production') {
  FlareIcon.displayName = 'FlareIcon';
  FlareIcon.propTypes = {
    color: propTypes.string
  };
}

var AmexIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FaCcAmex,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AmexIcon.displayName = 'AmexIcon';
  AmexIcon.propTypes = {
    color: propTypes.string
  };
}
var DinersClubIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FaCcDinersClub,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DinersClubIcon.displayName = 'DinersClubIcon';
  DinersClubIcon.propTypes = {
    color: propTypes.string
  };
}
var DiscoverIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FaCcDiscover,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DiscoverIcon.displayName = 'DiscoverIcon';
  DiscoverIcon.propTypes = {
    color: propTypes.string
  };
}
var JcbIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FaCcJcb,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  JcbIcon.displayName = 'JcbIcon';
  JcbIcon.propTypes = {
    color: propTypes.string
  };
}
var MastercardIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FaCcMastercard,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MastercardIcon.displayName = 'MastercardIcon';
  MastercardIcon.propTypes = {
    color: propTypes.string
  };
}
var VisaIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FaCcVisa,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  VisaIcon.displayName = 'VisaIcon';
  VisaIcon.propTypes = {
    color: propTypes.string
  };
}

var FaTruckIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FaTruck,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FaTruckIcon.displayName = 'FaTruckIcon';
  FaTruckIcon.propTypes = {
    color: propTypes.string,
    backgroundColor: propTypes.string
  };
}

var ActivityIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiActivity,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ActivityIcon.displayName = 'ActivityIcon';
}
var AirplayIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiAirplay,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AirplayIcon.displayName = 'AirplayIcon';
}
var AlertCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiAlertCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AlertCircleIcon.displayName = 'AlertCircleIcon';
}
var AlertOctagonIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiAlertOctagon,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AlertOctagonIcon.displayName = 'AlertOctagonIcon';
}
var AlertTriangleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiAlertTriangle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AlertTriangleIcon.displayName = 'AlertTriangleIcon';
}
var AlignCenterIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiAlignCenter,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AlignCenterIcon.displayName = 'AlignCenterIcon';
}
var AlignJustifyIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiAlignJustify,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AlignJustifyIcon.displayName = 'AlignJustifyIcon';
}
var AlignLeftIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiAlignLeft,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AlignLeftIcon.displayName = 'AlignLeftIcon';
}
var AlignRightIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiAlignRight,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AlignRightIcon.displayName = 'AlignRightIcon';
}
var AnchorIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiAnchor,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AnchorIcon.displayName = 'AnchorIcon';
}
var ApertureIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiAperture,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ApertureIcon.displayName = 'ApertureIcon';
}
var ArchiveIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArchive,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArchiveIcon.displayName = 'ArchiveIcon';
}
var ArrowDownCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArrowDownCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowDownCircleIcon.displayName = 'ArrowDownCircleIcon';
}
var ArrowDownLeftIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArrowDownLeft,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowDownLeftIcon.displayName = 'ArrowDownLeftIcon';
}
var ArrowDownRightIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArrowDownRight,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowDownRightIcon.displayName = 'ArrowDownRightIcon';
}
var ArrowDownIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArrowDown,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowDownIcon.displayName = 'ArrowDownIcon';
}
var ArrowLeftCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArrowLeftCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
}
var ArrowLeftIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArrowLeft,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowLeftIcon.displayName = 'ArrowLeftIcon';
}
var ArrowRightCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArrowRightCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
}
var ArrowRightIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArrowRight,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowRightIcon.displayName = 'ArrowRightIcon';
}
var ArrowUpCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArrowUpCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowUpCircleIcon.displayName = 'ArrowUpCircleIcon';
}
var ArrowUpLeftIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArrowUpLeft,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowUpLeftIcon.displayName = 'ArrowUpLeftIcon';
}
var ArrowUpRightIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArrowUpRight,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
}
var ArrowUpIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiArrowUp,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ArrowUpIcon.displayName = 'ArrowUpIcon';
}
var AtSignIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiAtSign,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AtSignIcon.displayName = 'AtSignIcon';
}
var AwardIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiAward,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  AwardIcon.displayName = 'AwardIcon';
}
var BarChart2Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBarChart2,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BarChart2Icon.displayName = 'BarChart2Icon';
}
var BarChartIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBarChart,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BarChartIcon.displayName = 'BarChartIcon';
}
var BatteryChargingIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBatteryCharging,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BatteryChargingIcon.displayName = 'BatteryChargingIcon';
}
var BatteryIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBattery,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BatteryIcon.displayName = 'BatteryIcon';
}
var BellOffIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBellOff,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BellOffIcon.displayName = 'BellOffIcon';
}
var BellIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBell,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BellIcon.displayName = 'BellIcon';
}
var BluetoothIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBluetooth,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BluetoothIcon.displayName = 'BluetoothIcon';
}
var BoldIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBold,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BoldIcon.displayName = 'BoldIcon';
}
var BookOpenIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBookOpen,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BookOpenIcon.displayName = 'BookOpenIcon';
}
var BookIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBook,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BookIcon.displayName = 'BookIcon';
}
var BookmarkIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBookmark,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BookmarkIcon.displayName = 'BookmarkIcon';
}
var BoxIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBox,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BoxIcon.displayName = 'BoxIcon';
}
var BriefcaseIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiBriefcase,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  BriefcaseIcon.displayName = 'BriefcaseIcon';
}
var CalendarIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCalendar,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CalendarIcon.displayName = 'CalendarIcon';
}
var CameraOffIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCameraOff,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CameraOffIcon.displayName = 'CameraOffIcon';
}
var CameraIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCamera,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CameraIcon.displayName = 'CameraIcon';
}
var CastIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCast,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CastIcon.displayName = 'CastIcon';
}
var CheckCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCheckCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CheckCircleIcon.displayName = 'CheckCircleIcon';
}
var CheckSquareIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCheckSquare,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CheckSquareIcon.displayName = 'CheckSquareIcon';
}
var CheckIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCheck,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CheckIcon.displayName = 'CheckIcon';
}
var ChevronDownIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiChevronDown,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ChevronDownIcon.displayName = 'ChevronDownIcon';
}
var ChevronLeftIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiChevronLeft,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ChevronLeftIcon.displayName = 'ChevronLeftIcon';
}
var ChevronRightIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiChevronRight,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ChevronRightIcon.displayName = 'ChevronRightIcon';
}
var ChevronUpIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiChevronUp,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ChevronUpIcon.displayName = 'ChevronUpIcon';
}
var ChevronsDownIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiChevronsDown,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ChevronsDownIcon.displayName = 'ChevronsDownIcon';
}
var ChevronsLeftIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiChevronsLeft,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ChevronsLeftIcon.displayName = 'ChevronsLeftIcon';
}
var ChevronsRightIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiChevronsRight,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ChevronsRightIcon.displayName = 'ChevronsRightIcon';
}
var ChevronsUpIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiChevronsUp,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ChevronsUpIcon.displayName = 'ChevronsUpIcon';
}
var ChromeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiChrome,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ChromeIcon.displayName = 'ChromeIcon';
}
var CircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CircleIcon.displayName = 'CircleIcon';
}
var ClipboardIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiClipboard,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ClipboardIcon.displayName = 'ClipboardIcon';
}
var ClockIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiClock,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ClockIcon.displayName = 'ClockIcon';
}
var CloudDrizzleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCloudDrizzle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CloudDrizzleIcon.displayName = 'CloudDrizzleIcon';
}
var CloudLightningIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCloudLightning,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CloudLightningIcon.displayName = 'CloudLightningIcon';
}
var CloudOffIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCloudOff,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CloudOffIcon.displayName = 'CloudOffIcon';
}
var CloudRainIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCloudRain,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CloudRainIcon.displayName = 'CloudRainIcon';
}
var CloudSnowIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCloudSnow,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CloudSnowIcon.displayName = 'CloudSnowIcon';
}
var CloudIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCloud,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CloudIcon.displayName = 'CloudIcon';
}
var CodeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCode,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CodeIcon.displayName = 'CodeIcon';
}
var CodepenIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCodepen,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CodepenIcon.displayName = 'CodepenIcon';
}
var CodesandboxIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCodesandbox,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CodesandboxIcon.displayName = 'CodesandboxIcon';
}
var CoffeeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCoffee,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CoffeeIcon.displayName = 'CoffeeIcon';
}
var ColumnsIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiColumns,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ColumnsIcon.displayName = 'ColumnsIcon';
}
var CommandIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCommand,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CommandIcon.displayName = 'CommandIcon';
}
var CompassIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCompass,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CompassIcon.displayName = 'CompassIcon';
}
var CopyIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCopy,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CopyIcon.displayName = 'CopyIcon';
}
var CornerDownLeftIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCornerDownLeft,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CornerDownLeftIcon.displayName = 'CornerDownLeftIcon';
}
var CornerDownRightIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCornerDownRight,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CornerDownRightIcon.displayName = 'CornerDownRightIcon';
}
var CornerLeftDownIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCornerLeftDown,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CornerLeftDownIcon.displayName = 'CornerLeftDownIcon';
}
var CornerLeftUpIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCornerLeftUp,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CornerLeftUpIcon.displayName = 'CornerLeftUpIcon';
}
var CornerRightDownIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCornerRightDown,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CornerRightDownIcon.displayName = 'CornerRightDownIcon';
}
var CornerRightUpIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCornerRightUp,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CornerRightUpIcon.displayName = 'CornerRightUpIcon';
}
var CornerUpLeftIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCornerUpLeft,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CornerUpLeftIcon.displayName = 'CornerUpLeftIcon';
}
var CornerUpRightIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCornerUpRight,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CornerUpRightIcon.displayName = 'CornerUpRightIcon';
}
var CpuIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCpu,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CpuIcon.displayName = 'CpuIcon';
}
var CreditCardIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCreditCard,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CreditCardIcon.displayName = 'CreditCardIcon';
}
var CropIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCrop,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CropIcon.displayName = 'CropIcon';
}
var CrosshairIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiCrosshair,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  CrosshairIcon.displayName = 'CrosshairIcon';
}
var DatabaseIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiDatabase,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DatabaseIcon.displayName = 'DatabaseIcon';
}
var DeleteIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiDelete,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DeleteIcon.displayName = 'DeleteIcon';
}
var DiscIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiDisc,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DiscIcon.displayName = 'DiscIcon';
}
var DivideCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiDivideCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DivideCircleIcon.displayName = 'DivideCircleIcon';
}
var DivideSquareIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiDivideSquare,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DivideSquareIcon.displayName = 'DivideSquareIcon';
}
var DivideIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiDivide,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DivideIcon.displayName = 'DivideIcon';
}
var DollarSignIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiDollarSign,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DollarSignIcon.displayName = 'DollarSignIcon';
}
var DownloadCloudIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiDownloadCloud,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DownloadCloudIcon.displayName = 'DownloadCloudIcon';
}
var DownloadIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiDownload,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DownloadIcon.displayName = 'DownloadIcon';
}
var DribbbleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiDribbble,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DribbbleIcon.displayName = 'DribbbleIcon';
}
var DropletIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiDroplet,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  DropletIcon.displayName = 'DropletIcon';
}
var Edit2Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiEdit2,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  Edit2Icon.displayName = 'Edit2Icon';
}
var Edit3Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiEdit3,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  Edit3Icon.displayName = 'Edit3Icon';
}
var EditIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiEdit,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  EditIcon.displayName = 'EditIcon';
}
var ExternalLinkIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiExternalLink,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ExternalLinkIcon.displayName = 'ExternalLinkIcon';
}
var EyeOffIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiEyeOff,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  EyeOffIcon.displayName = 'EyeOffIcon';
}
var EyeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiEye,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  EyeIcon.displayName = 'EyeIcon';
}
var FacebookIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFacebook,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FacebookIcon.displayName = 'FacebookIcon';
}
var FastForwardIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFastForward,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FastForwardIcon.displayName = 'FastForwardIcon';
}
var FeatherIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFeather,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FeatherIcon.displayName = 'FeatherIcon';
}
var FigmaIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFigma,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FigmaIcon.displayName = 'FigmaIcon';
}
var FileMinusIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFileMinus,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FileMinusIcon.displayName = 'FileMinusIcon';
}
var FilePlusIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFilePlus,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FilePlusIcon.displayName = 'FilePlusIcon';
}
var FileTextIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFileText,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FileTextIcon.displayName = 'FileTextIcon';
}
var FileIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFile,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FileIcon.displayName = 'FileIcon';
}
var FilmIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFilm,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FilmIcon.displayName = 'FilmIcon';
}
var FilterIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFilter,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FilterIcon.displayName = 'FilterIcon';
}
var FlagIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFlag,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FlagIcon.displayName = 'FlagIcon';
}
var FolderMinusIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFolderMinus,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FolderMinusIcon.displayName = 'FolderMinusIcon';
}
var FolderPlusIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFolderPlus,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FolderPlusIcon.displayName = 'FolderPlusIcon';
}
var FolderIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFolder,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FolderIcon.displayName = 'FolderIcon';
}
var FramerIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFramer,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FramerIcon.displayName = 'FramerIcon';
}
var FrownIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiFrown,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  FrownIcon.displayName = 'FrownIcon';
}
var GiftIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiGift,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  GiftIcon.displayName = 'GiftIcon';
}
var GitBranchIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiGitBranch,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  GitBranchIcon.displayName = 'GitBranchIcon';
}
var GitCommitIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiGitCommit,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  GitCommitIcon.displayName = 'GitCommitIcon';
}
var GitMergeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiGitMerge,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  GitMergeIcon.displayName = 'GitMergeIcon';
}
var GitPullRequestIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiGitPullRequest,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  GitPullRequestIcon.displayName = 'GitPullRequestIcon';
}
var GithubIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiGithub,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  GithubIcon.displayName = 'GithubIcon';
}
var GitlabIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiGitlab,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  GitlabIcon.displayName = 'GitlabIcon';
}
var GlobeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiGlobe,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  GlobeIcon.displayName = 'GlobeIcon';
}
var GridIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiGrid,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  GridIcon.displayName = 'GridIcon';
}
var HardDriveIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiHardDrive,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  HardDriveIcon.displayName = 'HardDriveIcon';
}
var HashIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiHash,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  HashIcon.displayName = 'HashIcon';
}
var HeadphonesIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiHeadphones,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  HeadphonesIcon.displayName = 'HeadphonesIcon';
}
var HeartIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiHeart,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  HeartIcon.displayName = 'HeartIcon';
}
var HelpCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiHelpCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  HelpCircleIcon.displayName = 'HelpCircleIcon';
}
var HexagonIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiHexagon,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  HexagonIcon.displayName = 'HexagonIcon';
}
var HomeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiHome,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  HomeIcon.displayName = 'HomeIcon';
}
var ImageIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiImage,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ImageIcon.displayName = 'ImageIcon';
}
var InboxIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiInbox,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  InboxIcon.displayName = 'InboxIcon';
}
var InfoIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiInfo,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  InfoIcon.displayName = 'InfoIcon';
}
var InstagramIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiInstagram,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  InstagramIcon.displayName = 'InstagramIcon';
}
var ItalicIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiItalic,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ItalicIcon.displayName = 'ItalicIcon';
}
var KeyIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiKey,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  KeyIcon.displayName = 'KeyIcon';
}
var LayersIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiLayers,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  LayersIcon.displayName = 'LayersIcon';
}
var LayoutIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiLayout,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  LayoutIcon.displayName = 'LayoutIcon';
}
var LifeBuoyIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiLifeBuoy,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  LifeBuoyIcon.displayName = 'LifeBuoyIcon';
}
var Link2Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiLink2,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  Link2Icon.displayName = 'Link2Icon';
}
var LinkIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiLink,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  LinkIcon.displayName = 'LinkIcon';
}
var LinkedinIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiLinkedin,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  LinkedinIcon.displayName = 'LinkedinIcon';
}
var ListIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiList,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ListIcon.displayName = 'ListIcon';
}
var LoaderIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiLoader,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  LoaderIcon.displayName = 'LoaderIcon';
}
var LockIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiLock,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  LockIcon.displayName = 'LockIcon';
}
var LogInIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiLogIn,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  LogInIcon.displayName = 'LogInIcon';
}
var LogOutIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiLogOut,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  LogOutIcon.displayName = 'LogOutIcon';
}
var MailIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMail,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MailIcon.displayName = 'MailIcon';
}
var MapPinIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMapPin,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MapPinIcon.displayName = 'MapPinIcon';
}
var MapIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMap,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MapIcon.displayName = 'MapIcon';
}
var Maximize2Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMaximize2,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  Maximize2Icon.displayName = 'Maximize2Icon';
}
var MaximizeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMaximize,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MaximizeIcon.displayName = 'MaximizeIcon';
}
var MehIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMeh,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MehIcon.displayName = 'MehIcon';
}
var MenuIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMenu,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MenuIcon.displayName = 'MenuIcon';
}
var MessageCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMessageCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MessageCircleIcon.displayName = 'MessageCircleIcon';
}
var MessageSquareIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMessageSquare,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MessageSquareIcon.displayName = 'MessageSquareIcon';
}
var MicOffIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMicOff,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MicOffIcon.displayName = 'MicOffIcon';
}
var MicIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMic,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MicIcon.displayName = 'MicIcon';
}
var Minimize2Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMinimize2,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  Minimize2Icon.displayName = 'Minimize2Icon';
}
var MinimizeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMinimize,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MinimizeIcon.displayName = 'MinimizeIcon';
}
var MinusCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMinusCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MinusCircleIcon.displayName = 'MinusCircleIcon';
}
var MinusSquareIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMinusSquare,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MinusSquareIcon.displayName = 'MinusSquareIcon';
}
var MinusIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMinus,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MinusIcon.displayName = 'MinusIcon';
}
var MonitorIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMonitor,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MonitorIcon.displayName = 'MonitorIcon';
}
var MoonIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMoon,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MoonIcon.displayName = 'MoonIcon';
}
var MoreHorizontalIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMoreHorizontal,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MoreHorizontalIcon.displayName = 'MoreHorizontalIcon';
}
var MoreVerticalIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMoreVertical,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MoreVerticalIcon.displayName = 'MoreVerticalIcon';
}
var MousePointerIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMousePointer,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MousePointerIcon.displayName = 'MousePointerIcon';
}
var MoveIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMove,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MoveIcon.displayName = 'MoveIcon';
}
var MusicIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiMusic,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  MusicIcon.displayName = 'MusicIcon';
}
var Navigation2Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiNavigation2,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  Navigation2Icon.displayName = 'Navigation2Icon';
}
var NavigationIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiNavigation,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  NavigationIcon.displayName = 'NavigationIcon';
}
var OctagonIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiOctagon,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  OctagonIcon.displayName = 'OctagonIcon';
}
var PackageIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPackage,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PackageIcon.displayName = 'PackageIcon';
}
var PaperclipIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPaperclip,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PaperclipIcon.displayName = 'PaperclipIcon';
}
var PauseCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPauseCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PauseCircleIcon.displayName = 'PauseCircleIcon';
}
var PauseIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPause,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PauseIcon.displayName = 'PauseIcon';
}
var PenToolIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPenTool,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PenToolIcon.displayName = 'PenToolIcon';
}
var PercentIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPercent,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PercentIcon.displayName = 'PercentIcon';
}
var PhoneCallIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPhoneCall,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PhoneCallIcon.displayName = 'PhoneCallIcon';
}
var PhoneForwardedIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPhoneForwarded,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PhoneForwardedIcon.displayName = 'PhoneForwardedIcon';
}
var PhoneIncomingIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPhoneIncoming,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PhoneIncomingIcon.displayName = 'PhoneIncomingIcon';
}
var PhoneMissedIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPhoneMissed,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PhoneMissedIcon.displayName = 'PhoneMissedIcon';
}
var PhoneOffIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPhoneOff,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PhoneOffIcon.displayName = 'PhoneOffIcon';
}
var PhoneOutgoingIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPhoneOutgoing,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PhoneOutgoingIcon.displayName = 'PhoneOutgoingIcon';
}
var PhoneIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPhone,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PhoneIcon.displayName = 'PhoneIcon';
}
var PieChartIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPieChart,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PieChartIcon.displayName = 'PieChartIcon';
}
var PlayCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPlayCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PlayCircleIcon.displayName = 'PlayCircleIcon';
}
var PlayIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPlay,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PlayIcon.displayName = 'PlayIcon';
}
var PlusCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPlusCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PlusCircleIcon.displayName = 'PlusCircleIcon';
}
var PlusSquareIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPlusSquare,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PlusSquareIcon.displayName = 'PlusSquareIcon';
}
var PlusIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPlus,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PlusIcon.displayName = 'PlusIcon';
}
var PocketIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPocket,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PocketIcon.displayName = 'PocketIcon';
}
var PowerIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPower,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PowerIcon.displayName = 'PowerIcon';
}
var PrinterIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiPrinter,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  PrinterIcon.displayName = 'PrinterIcon';
}
var RadioIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiRadio,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  RadioIcon.displayName = 'RadioIcon';
}
var RefreshCcwIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiRefreshCcw,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  RefreshCcwIcon.displayName = 'RefreshCcwIcon';
}
var RefreshCwIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiRefreshCw,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  RefreshCwIcon.displayName = 'RefreshCwIcon';
}
var RepeatIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiRepeat,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  RepeatIcon.displayName = 'RepeatIcon';
}
var RewindIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiRewind,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  RewindIcon.displayName = 'RewindIcon';
}
var RotateCcwIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiRotateCcw,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  RotateCcwIcon.displayName = 'RotateCcwIcon';
}
var RotateCwIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiRotateCw,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  RotateCwIcon.displayName = 'RotateCwIcon';
}
var RssIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiRss,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  RssIcon.displayName = 'RssIcon';
}
var SaveIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSave,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SaveIcon.displayName = 'SaveIcon';
}
var ScissorsIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiScissors,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ScissorsIcon.displayName = 'ScissorsIcon';
}
var SearchIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSearch,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SearchIcon.displayName = 'SearchIcon';
}
var SendIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSend,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SendIcon.displayName = 'SendIcon';
}
var ServerIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiServer,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ServerIcon.displayName = 'ServerIcon';
}
var SettingsIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSettings,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SettingsIcon.displayName = 'SettingsIcon';
}
var Share2Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiShare2,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  Share2Icon.displayName = 'Share2Icon';
}
var ShareIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiShare,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ShareIcon.displayName = 'ShareIcon';
}
var ShieldOffIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiShieldOff,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ShieldOffIcon.displayName = 'ShieldOffIcon';
}
var ShieldIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiShield,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ShieldIcon.displayName = 'ShieldIcon';
}
var ShoppingBagIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiShoppingBag,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ShoppingBagIcon.displayName = 'ShoppingBagIcon';
}
var ShoppingCartIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiShoppingCart,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ShoppingCartIcon.displayName = 'ShoppingCartIcon';
}
var ShuffleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiShuffle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ShuffleIcon.displayName = 'ShuffleIcon';
}
var SidebarIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSidebar,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SidebarIcon.displayName = 'SidebarIcon';
}
var SkipBackIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSkipBack,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SkipBackIcon.displayName = 'SkipBackIcon';
}
var SkipForwardIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSkipForward,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SkipForwardIcon.displayName = 'SkipForwardIcon';
}
var SlackIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSlack,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SlackIcon.displayName = 'SlackIcon';
}
var SlashIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSlash,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SlashIcon.displayName = 'SlashIcon';
}
var SlidersIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSliders,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SlidersIcon.displayName = 'SlidersIcon';
}
var SmartphoneIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSmartphone,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SmartphoneIcon.displayName = 'SmartphoneIcon';
}
var SmileIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSmile,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SmileIcon.displayName = 'SmileIcon';
}
var SpeakerIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSpeaker,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SpeakerIcon.displayName = 'SpeakerIcon';
}
var SquareIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSquare,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SquareIcon.displayName = 'SquareIcon';
}
var StarIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiStar,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  StarIcon.displayName = 'StarIcon';
}
var StopCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiStopCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  StopCircleIcon.displayName = 'StopCircleIcon';
}
var SunIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSun,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SunIcon.displayName = 'SunIcon';
}
var SunriseIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSunrise,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SunriseIcon.displayName = 'SunriseIcon';
}
var SunsetIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiSunset,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  SunsetIcon.displayName = 'SunsetIcon';
}
var TabletIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTablet,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TabletIcon.displayName = 'TabletIcon';
}
var TagIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTag,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TagIcon.displayName = 'TagIcon';
}
var TargetIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTarget,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TargetIcon.displayName = 'TargetIcon';
}
var TerminalIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTerminal,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TerminalIcon.displayName = 'TerminalIcon';
}
var ThermometerIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiThermometer,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ThermometerIcon.displayName = 'ThermometerIcon';
}
var ThumbsDownIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiThumbsDown,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ThumbsDownIcon.displayName = 'ThumbsDownIcon';
}
var ThumbsUpIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiThumbsUp,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ThumbsUpIcon.displayName = 'ThumbsUpIcon';
}
var ToggleLeftIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiToggleLeft,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ToggleLeftIcon.displayName = 'ToggleLeftIcon';
}
var ToggleRightIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiToggleRight,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ToggleRightIcon.displayName = 'ToggleRightIcon';
}
var ToolIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTool,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ToolIcon.displayName = 'ToolIcon';
}
var Trash2Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTrash2,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  Trash2Icon.displayName = 'Trash2Icon';
}
var TrashIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTrash,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TrashIcon.displayName = 'TrashIcon';
}
var TrelloIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTrello,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TrelloIcon.displayName = 'TrelloIcon';
}
var TrendingDownIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTrendingDown,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TrendingDownIcon.displayName = 'TrendingDownIcon';
}
var TrendingUpIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTrendingUp,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TrendingUpIcon.displayName = 'TrendingUpIcon';
}
var TriangleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTriangle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TriangleIcon.displayName = 'TriangleIcon';
}
var TruckIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTruck,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TruckIcon.displayName = 'TruckIcon';
}
var TvIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTv,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TvIcon.displayName = 'TvIcon';
}
var TwitchIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTwitch,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TwitchIcon.displayName = 'TwitchIcon';
}
var TwitterIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiTwitter,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TwitterIcon.displayName = 'TwitterIcon';
}
var TypeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiType,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  TypeIcon.displayName = 'TypeIcon';
}
var UmbrellaIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiUmbrella,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  UmbrellaIcon.displayName = 'UmbrellaIcon';
}
var UnderlineIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiUnderline,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  UnderlineIcon.displayName = 'UnderlineIcon';
}
var UnlockIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiUnlock,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  UnlockIcon.displayName = 'UnlockIcon';
}
var UploadCloudIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiUploadCloud,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  UploadCloudIcon.displayName = 'UploadCloudIcon';
}
var UploadIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiUpload,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  UploadIcon.displayName = 'UploadIcon';
}
var UserCheckIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiUserCheck,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  UserCheckIcon.displayName = 'UserCheckIcon';
}
var UserMinusIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiUserMinus,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  UserMinusIcon.displayName = 'UserMinusIcon';
}
var UserPlusIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiUserPlus,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  UserPlusIcon.displayName = 'UserPlusIcon';
}
var UserXIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiUserX,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  UserXIcon.displayName = 'UserXIcon';
}
var UserIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiUser,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  UserIcon.displayName = 'UserIcon';
}
var UsersIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiUsers,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  UsersIcon.displayName = 'UsersIcon';
}
var VideoOffIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiVideoOff,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  VideoOffIcon.displayName = 'VideoOffIcon';
}
var VideoIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiVideo,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  VideoIcon.displayName = 'VideoIcon';
}
var VoicemailIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiVoicemail,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  VoicemailIcon.displayName = 'VoicemailIcon';
}
var Volume1Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiVolume1,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  Volume1Icon.displayName = 'Volume1Icon';
}
var Volume2Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiVolume2,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  Volume2Icon.displayName = 'Volume2Icon';
}
var VolumeXIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiVolumeX,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  VolumeXIcon.displayName = 'VolumeXIcon';
}
var VolumeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiVolume,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  VolumeIcon.displayName = 'VolumeIcon';
}
var WatchIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiWatch,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  WatchIcon.displayName = 'WatchIcon';
}
var WifiOffIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiWifiOff,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  WifiOffIcon.displayName = 'WifiOffIcon';
}
var WifiIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiWifi,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  WifiIcon.displayName = 'WifiIcon';
}
var WindIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiWind,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  WindIcon.displayName = 'WindIcon';
}
var XCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiXCircle,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  XCircleIcon.displayName = 'XCircleIcon';
}
var XOctagonIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiXOctagon,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  XOctagonIcon.displayName = 'XOctagonIcon';
}
var XSquareIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiXSquare,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  XSquareIcon.displayName = 'XSquareIcon';
}
var XIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiX,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  XIcon.displayName = 'XIcon';
}
var YoutubeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiYoutube,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  YoutubeIcon.displayName = 'YoutubeIcon';
}
var ZapOffIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiZapOff,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ZapOffIcon.displayName = 'ZapOffIcon';
}
var ZapIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiZap,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ZapIcon.displayName = 'ZapIcon';
}
var ZoomInIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiZoomIn,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ZoomInIcon.displayName = 'ZoomInIcon';
}
var ZoomOutIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: FiZoomOut,
    color: "scheme.textPrimary"
  }, props));
});
if (process.env.NODE_ENV !== 'production') {
  ZoomOutIcon.displayName = 'ZoomOutIcon';
}

export { ActivityIcon, AirplayIcon, AlertCircleIcon, AlertOctagonIcon, AlertTriangleIcon, AlignCenterIcon, AlignJustifyIcon, AlignLeftIcon, AlignRightIcon, AmexIcon, AnchorIcon, ApertureIcon, AppleIcon, ArchiveIcon, ArrowDownCircleIcon, ArrowDownIcon, ArrowDownLeftIcon, ArrowDownRightIcon, ArrowLeftCircleIcon, ArrowLeftIcon, ArrowRightCircleIcon, ArrowRightIcon, ArrowUpCircleIcon, ArrowUpIcon, ArrowUpLeftIcon, ArrowUpRightIcon, AtSignIcon, AwardIcon, BadgeCheckIcon, BarChart2Icon, BarChartIcon, BatteryChargingIcon, BatteryIcon, BellIcon, BellOffIcon, BluetoothIcon, BoldIcon, BookIcon, BookOpenIcon, BookmarkIcon, BoxIcon, BriefcaseIcon, CalendarIcon, CameraIcon, CameraOffIcon, CastIcon, CheckCircleIcon, CheckIcon, CheckSquareIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, ChevronsDownIcon, ChevronsLeftIcon, ChevronsRightIcon, ChevronsUpIcon, ChromeIcon, CircleIcon, ClipboardIcon, ClockIcon, CloudDrizzleIcon, CloudIcon, CloudLightningIcon, CloudOffIcon, CloudRainIcon, CloudSnowIcon, CodeIcon, CodepenIcon, CodesandboxIcon, CoffeeIcon, ColumnsIcon, CommandIcon, CompassIcon, CopyIcon, CornerDownLeftIcon, CornerDownRightIcon, CornerLeftDownIcon, CornerLeftUpIcon, CornerRightDownIcon, CornerRightUpIcon, CornerUpLeftIcon, CornerUpRightIcon, CpuIcon, CreditCardIcon, CropIcon, CrosshairIcon, DatabaseIcon, DeleteIcon, DinersClubIcon, DiscIcon, DiscoverIcon, DivideCircleIcon, DivideIcon, DivideSquareIcon, DollarSignIcon, DownloadCloudIcon, DownloadIcon, DribbbleIcon, DropletIcon, Edit2Icon, Edit3Icon, EditIcon, ExternalLinkIcon, EyeIcon, EyeOffIcon, FaFacebookIcon, FaTruckIcon, FacebookIcon, FastForwardIcon, FeatherIcon, FigmaIcon, FileIcon, FileMinusIcon, FilePlusIcon, FileTextIcon, FilmIcon, FilterIcon, FlagIcon, FlareIcon, FolderIcon, FolderMinusIcon, FolderPlusIcon, FramerIcon, FrownIcon, GiftIcon, GitBranchIcon, GitCommitIcon, GitMergeIcon, GitPullRequestIcon, GithubIcon, GitlabIcon, GlobeIcon, GoogleIcon, GridIcon, HardDriveIcon, HashIcon, HeadphonesIcon, HeartIcon, HelpCircleIcon, HexagonIcon, HomeIcon, ImageIcon, InboxIcon, InfoIcon, InstagramIcon, ItalicIcon, JcbIcon, KeyIcon, LayersIcon, LayoutIcon, LifeBuoyIcon, Link2Icon, LinkIcon, LinkedinIcon, ListIcon, LoaderIcon, LockIcon, LogInIcon, LogOutIcon, MailIcon, MapIcon, MapPinIcon, MastercardIcon, Maximize2Icon, MaximizeIcon, MehIcon, MenuIcon, MessageCircleIcon, MessageSquareIcon, MicIcon, MicOffIcon, Minimize2Icon, MinimizeIcon, MinusCircleIcon, MinusIcon, MinusSquareIcon, MonitorIcon, MoonIcon, MoreHorizontalIcon, MoreVerticalIcon, MousePointerIcon, MoveIcon, MusicIcon, Navigation2Icon, NavigationIcon, OctagonIcon, PackageIcon, PaperclipIcon, PauseCircleIcon, PauseIcon, PenToolIcon, PercentIcon, PhoneCallIcon, PhoneForwardedIcon, PhoneIcon, PhoneIncomingIcon, PhoneMissedIcon, PhoneOffIcon, PhoneOutgoingIcon, PieChartIcon, PlayCircleIcon, PlayIcon, PlusCircleIcon, PlusIcon, PlusSquareIcon, PocketIcon, PowerIcon, PrinterIcon, RadioIcon, RefreshCcwIcon, RefreshCwIcon, RepeatIcon, RewindIcon, RotateCcwIcon, RotateCwIcon, RssIcon, SaveIcon, ScissorsIcon, SearchIcon, SendIcon, ServerIcon, SettingsIcon, Share2Icon, ShareIcon, ShieldIcon, ShieldOffIcon, ShoppingBagIcon, ShoppingCartIcon, ShuffleIcon, SidebarIcon, SkipBackIcon, SkipForwardIcon, SlackIcon, SlashIcon, SlidersIcon, SmartphoneIcon, SmileIcon, SpeakerIcon, SquareIcon, StarIcon, StopCircleIcon, SunIcon, SunriseIcon, SunsetIcon, TabletIcon, TagIcon, TargetIcon, TerminalIcon, ThermometerIcon, ThumbsDownIcon, ThumbsUpIcon, ToggleLeftIcon, ToggleRightIcon, ToolIcon, Trash2Icon, TrashIcon, TrelloIcon, TrendingDownIcon, TrendingUpIcon, TriangleIcon, TruckIcon, TvIcon, TwitchIcon, TwitterIcon, TypeIcon, UmbrellaIcon, UnderlineIcon, UnlockIcon, UploadCloudIcon, UploadIcon, UserCheckIcon, UserIcon, UserMinusIcon, UserPlusIcon, UserXIcon, UsersIcon, VideoIcon, VideoOffIcon, VisaIcon, VoicemailIcon, Volume1Icon, Volume2Icon, VolumeIcon, VolumeXIcon, WatchIcon, WifiIcon, WifiOffIcon, WindIcon, XCircleIcon, XIcon, XOctagonIcon, XSquareIcon, YoutubeIcon, ZapIcon, ZapOffIcon, ZoomInIcon, ZoomOutIcon };
